export default {"src":"/_next/static/media/TTD.f387c05b.svg","height":18,"width":18};